<mat-form-field>
  <mat-label>{{ capData.date | date: "fullDate" }}</mat-label>
  <input type="number" matInput name="valCap[]" [formControl]="cap" value="{{ capData.cap }}" placeholder="Ex. 10" #input>
  <input type="hidden" name="date[]" value="{{ capData.date | standardDateOnly }}">
  <mat-hint align="start">Shift cap (Day: {{ capData.dayShiftCap || 0 }} | Night: {{ capData.nightShiftCap || 0 }})
  </mat-hint>
</mat-form-field>
